import { Redirect } from 'react-router-dom';

import { allowPermission, LOCATIONS } from 'constants/index';

import Profile from 'pages/Authentication/Profile';
import ChangePassword from 'pages/Authentication/ChangePassword';
import Contract from 'pages/Contract';

import ForgotPwd from 'pages/Authentication/ForgotPassword';
import Login from 'pages/Authentication/Login';
import Register from 'pages/Authentication/Register';

import Dashboard from 'pages/Dashboard/index';

import Media from 'pages/Media';
import MediaDetail from 'pages/Media/MediaDetail';

import EditLocation from 'pages/Location/EditLocation';
import LocationList from 'pages/Location/LocationList';
import LocationDetail from 'pages/Location/LocationDetail';
import AddAlreadyLocation from 'pages/Location/EditLocation/AddAlreadyLocation';
import FavoritePlace from 'pages/Location/FavoritePlace';
// import LocationPolicy from 'pages/Location/Policy';
import LocationContactInfo from 'pages/Location/ContactInfo';
import LocationPolicy from 'pages/Location/LocationDetail/Policy';
import LocationCancelPolicy from 'pages/Location/LocationDetail/CancellationPolicy';
import LocationConveniencesServices from 'pages/Location/LocationDetail/ConveniencesServices';
import VatService from 'pages/Location/LocationDetail/VatService';

import OpenCloseRoom from 'pages/Location/LocationDetail/OpenCloseRoom';
import AmountRoom from 'pages/Location/LocationDetail/AmountRoom';
import Price from 'pages/Location/LocationDetail/Price';
import PriceType from 'pages/Location/LocationDetail/PriceType';
import EditPriceType from 'pages/Location/LocationDetail/EditPriceType';
import Review from 'pages/Location/LocationDetail/Review';

import CreateNewRoom from 'pages/Location/LocationDetail/Policy/TypeRoom/CreateNewRoom';
import RoomsOfPlace from 'pages/Location/LocationDetail/RoomsOfPlace';

import ConvenienceRoom from 'pages/Location/ConvenienceRoom';
import Calendar from 'pages/Location/Calendar';
import ManagerBooking from 'pages/ManagerBooking';
import BookingDetail from 'pages/ManagerBooking/BookingDetail';
import ManagerPicture from 'pages/Location/LocationDetail/ManagerPicture';
import EditChildExtraBedPolicy from 'pages/Location/LocationDetail/Policy/EditChildExtraBedPolicy';
import ReviewDetail from 'pages/Location/LocationDetail/ReviewDetail';
import Promotions from 'pages/Location/LocationDetail/Promotions';
import CreatePromotion from 'pages/Location/LocationDetail/CreatePromotion';
import CreateBasicPromotion from 'pages/Location/LocationDetail/CreateBasicPromotion';
import CreateLongTermPromotion from 'pages/Location/LocationDetail/CreateLongTermPromotion';
import CreateLastMinutePromotion from 'pages/Location/LocationDetail/CreateLastMinutePromotion';
import CreateEarlyPromotion from 'pages/Location/LocationDetail/CreateEarlyPromotion';
import CreateTouristPromotion from 'pages/Location/LocationDetail/CreateTouristPromotion';
import CreateRankPromotion from 'pages/Location/LocationDetail/CreateRankPromotion';
import CreateMarketingPromotion from 'pages/Location/LocationDetail/CreateMarketingPromotion';
import Customers from 'pages/Customers';
import ManagerReviews from 'pages/ManagerReviews';
import ManagerReviewDetail from 'pages/ManagerReviews/ReviewDetail';
import CustomerDetails from 'pages/CustomerDetails';
import Finance from 'pages/Location/LocationDetail/Finance';
import FinanceDetail from 'pages/Location/LocationDetail/Finance/FinanceDetail';
import AnalyticsOverview from 'pages/Location/LocationDetail/AnalyticsOverview';
import MessagesWithCustomers from 'pages/Location/LocationDetail/MessagesWithCustomers';

// import ManagerUserAccount from 'pages/ManagerUserAccount';
import ManagerInternalAccount from 'pages/ManagerAccount/ManagerInternalAccount';
import ManagerAccommodationAccount from 'pages/ManagerAccount/ManagerAccommodationAccount';
import ManagerCustomerAccount from 'pages/ManagerAccount/ManagerCustomerAccount/index';
import LocationManagerBooking from 'pages/Location/LocationDetail/LocationManagerBooking';
import CreatePassword from 'pages/Authentication/CreatePassword';
import ManagerDiscoveryCategories from 'pages/ManagerDiscoveryCategories';
import DiscoveryCategoriesDetails from 'pages/DiscoveryCategoriesDetails';
import ManagerDiscoveryProvinces from 'pages/ManagerDiscoveryProvinces';
import DiscoveryProvincesDetails from 'pages/DiscoveryProvincesDetails';
import ManagerDiscoveryPlaceCreate from 'pages/ManagerDiscoveryPlaceCreate';
import ManagerDiscoveryPlaceDetails from 'pages/ManagerDiscoveryPlaceDetails';
import ManagerDiscoveryReview from 'pages/ManagerDiscoveryReview';
import DiscoveryLocation from 'pages/DiscoveryLocation/DiscoveryLocation';
import ManagerDiscoveryPlaceEdit from 'pages/ManagerDiscoveryPlaceEdit';
import ManagerGiftCreate from 'pages/ManagerGiftCreate';
import ManagerGiftExchange from 'pages/ManagerGiftExchange';
import ManagerGiftExchangeDetail from 'pages/ManagerGiftExchangeDetail';
import ManagerMarket from 'pages/ManagerMarket';
import ManagerAreas from 'pages/ManagerAreas';
import ManagerOperation from 'pages/ManagerOperation';
import ManagerPromotion from 'pages/ManagerPromotion';
import ManagerGiftList from 'pages/ManagerGiftList';
import ManagerVoucherCampaign from 'pages/ManagerVoucherCampaign';
import ManagerVoucher from 'pages/ManagerVoucher';
import ManagerFlightBooking from 'pages/ManagerFlightBooking';
import ManagerFlightBookingDetail from 'pages/ManagerFlightBookingDetail';
import ManagerFlightRevenue from 'pages/ManagerFlightRevenue';
import ManagerFlightSetting from 'pages/ManagerFlightSetting';
import ManagerGiftListDetail from 'pages/ManagerGiftListDetail';
import ENDPOINT from 'constants/endPoint';
import LocationNearLocation from 'pages/Location/LocationDetail/NearLocation';
import CreateEnterprisePromotion from 'pages/Location/LocationDetail/CreateEnterprisePromotion';
import CreateAgencyPromotion from 'pages/Location/LocationDetail/CreateAgencyPromotion';
import ManagerRevenue from 'pages/ManagerRevenue';
import ManagerPayment from 'pages/ManagerPayment';
import PaymentDetail from 'pages/ManagerPayment/[id]';
import ManagerCoin from 'pages/ManagerCoin/ManagerCoin';
import ManagerTax from 'pages/ManagerTax';
import ManagerComplaint from 'pages/ManagerComplaint';
import ComplaintDetail from 'pages/ManagerComplaint/ComplaintDetail';
import ManagerReflect from 'pages/ManagerReflect';
import TcxhFeedbackDetail from 'pages/ManagerReflect/TcxhFeedbackDetail';

const authProtectedRoutes = [
  { path: LOCATIONS.DASHBOARD, exact: true, component: Dashboard },

  // profile
  { path: LOCATIONS.PROFILE, exact: true, component: Profile },
  { path: LOCATIONS.CHANGE_PASSWORD, exact: true, component: ChangePassword },
  { path: LOCATIONS.CONTRACT, exact: true, component: Contract },

  // Media
  {
    path: LOCATIONS.MEDIA,
    component: Media,
    exact: true,
    permission: allowPermission.VIEW_ALL_MEDIA,
  },
  {
    path: LOCATIONS.MEDIA_VIEW,
    component: MediaDetail,
    permission: allowPermission.VIEW_DETAIL_MEDIA,
  },

  // manager booking
  {
    path: LOCATIONS.MANAGER_BOOKING,
    component: ManagerBooking,
    exact: true,
  },
  {
    path: LOCATIONS.MANAGER_BOOKING_DETAIL,
    component: BookingDetail,
    exact: true,
  },

  // Location
  {
    path: LOCATIONS.LOCATION_ADD,
    component: EditLocation,
    exact: true,
  },
  {
    path: LOCATIONS.ADD_ALREADY_LOCATION,
    component: AddAlreadyLocation,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_LIST,
    component: LocationList,
    exact: true,
  },
  {
    path: LOCATIONS.FAVORITE_PLACE,
    component: FavoritePlace,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.DASHBOARD,
    component: Dashboard,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.DEFAULT,
    component: LocationDetail,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.POLICY,
    component: LocationPolicy,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.CANCELLATION_POLICY,
    component: LocationCancelPolicy,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.DETAIL_PICTURE,
    component: ManagerPicture,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.VAT_SERVICE,
    component: VatService,
    exact: true,
  },

  // CREATE AND DETAIL ROOM
  {
    path: LOCATIONS.LOCATION_DETAIL.CONVENIENCE_SERVICE,
    component: LocationConveniencesServices,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.NEAR_LOCATION,
    component: LocationNearLocation,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.DETAIL_CALENDAR,
    component: Calendar,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.OPEN_CLOSE_ROOM,
    component: OpenCloseRoom,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.UPDATE_AMOUNT_ROOM,
    component: AmountRoom,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.UPDATE_PRICE,
    component: Price,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.LIST_PRICE_TYPE,
    component: PriceType,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.ADD_PRICE_TYPE,
    component: EditPriceType,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.EDIT_PRICE_TYPE,
    component: EditPriceType,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_ROOM,
    component: CreateNewRoom,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.EDIT_ROOM,
    component: CreateNewRoom,
    exact: true,
  },

  // EDIT CONVENIENCE ROOM
  {
    path: LOCATIONS.LOCATION_DETAIL.CONVENIENCE_ROOM,
    component: ConvenienceRoom,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.CONVENIENCE_SERVICE,
    component: LocationConveniencesServices,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.ROOMS_OF_PLACE,
    component: RoomsOfPlace,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.CONTACT_INFORMATION,
    component: LocationContactInfo,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.CHILD_EXTRA_BED_POLICY,
    component: EditChildExtraBedPolicy,
    exact: true,
  },

  // REVIEW IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.DETAIL_REVIEWS,
    component: Review,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.REVIEW_DETAIL,
    component: ReviewDetail,
    exact: true,
  },

  // PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.PROMOTION,
    component: Promotions,
    exact: true,
  },

  // MANAGER BOOKING IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.MANAGER_BOOKING,
    component: LocationManagerBooking,
    exact: true,
  },

  // CREATE PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_PROMOTION,
    component: CreatePromotion,
    exact: true,
  },

  // CREATE BASIC PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_BASIC_PROMOTION,
    component: CreateBasicPromotion,
    exact: true,
  },

  // CREATE LONG TERM PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_LONG_TERM_PROMOTION,
    component: CreateLongTermPromotion,
    exact: true,
  },

  // CREATE LAST MINUTE PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_LAST_MINUTE_PROMOTION,
    component: CreateLastMinutePromotion,
    exact: true,
  },

  // CREATE EARLY PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_EARLY_PROMOTION,
    component: CreateEarlyPromotion,
    exact: true,
  },

  // CREATE TOURIST PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_TOURIST_PROMOTION,
    component: CreateTouristPromotion,
    exact: true,
  },

  // CREATE ENTERPRISE PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_ENTERPRISE_PROMOTION,
    component: CreateEnterprisePromotion,
    exact: true,
  },

  // CREATE AGENCY PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_AGENCY_PROMOTION,
    component: CreateAgencyPromotion,
    exact: true,
  },
  // CREATE RANK PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_RANK_PROMOTION,
    component: CreateRankPromotion,
    exact: true,
  },
  // CREATE MARKETING PROMOTION IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.CREATE_MARKETING_PROMOTION,
    component: CreateMarketingPromotion,
    exact: true,
  },

  // FINANCE IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.FINANCE,
    component: Finance,
    exact: true,
  },
  {
    path: LOCATIONS.LOCATION_DETAIL.FINANCE_DETAIL,
    component: FinanceDetail,
    exact: true,
  },

  {
    path: LOCATIONS.CUSTOMERS,
    component: Customers,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: LOCATIONS.MANAGER_REVIEWS,
    component: ManagerReviews,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: LOCATIONS.MANAGER_REVIEWS_DETAIL,
    component: ManagerReviewDetail,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: LOCATIONS.CUSTOMER_DETAILS,
    component: CustomerDetails,
    loginTypes: ['INTRANET'],
  },

  // ANALYTICS OVERVIEW IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.ANALYSIS_OVERVIEW,
    component: AnalyticsOverview,
    exact: true,
  },

  // MESSAGES WITH CUSTOMERS IN LOCATION DETAIL
  {
    path: LOCATIONS.LOCATION_DETAIL.MESSAGES_WITH_CUSTOMERS,
    component: MessagesWithCustomers,
    exact: true,
  },

  // MANAGER USER ACCOUNT
  // {
  //   path: LOCATIONS.MANAGER_USER_ACCOUNT,
  //   component: ManagerUserAccount,
  //   exact: true,
  //   loginTypes: ['INTRANET'],
  // },

  // MANAGER ACCOUNT
  {
    path: LOCATIONS.MANAGER_INTERNAL_ACCOUNT,
    component: ManagerInternalAccount,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: LOCATIONS.MANAGER_ACCOMMODATION_ACCOUNT,
    component: ManagerAccommodationAccount,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: LOCATIONS.MANAGER_CUSTOMER_ACCOUNT,
    component: ManagerCustomerAccount,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  // MANAGER DISCOVERY
  {
    path: '/manager-discovery/category',
    component: ManagerDiscoveryCategories,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: '/manager-discovery/destination',
    component: ManagerDiscoveryProvinces,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: '/manager-discovery/review',
    component: ManagerDiscoveryReview,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: '/manager-discovery/destination/:id',
    component: DiscoveryProvincesDetails,
    loginTypes: ['INTRANET'],
  },

  // {
  //   path: '/manager-discovery/place',
  //   component: ManagerDiscoveryPlace,
  //   exact: true,
  // },
  {
    path: '/manager-discovery/place',
    component: DiscoveryLocation,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: '/manager-discovery/category/:id',
    component: DiscoveryCategoriesDetails,
    loginTypes: ['INTRANET'],
  },

  {
    path: ENDPOINT.MANAGER_DISCOVERY_PLACE_CREATE,
    component: ManagerDiscoveryPlaceCreate,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: '/manager-discovery/place/edit/:id',
    component: ManagerDiscoveryPlaceEdit,
    loginTypes: ['INTRANET'],
  },

  {
    path: '/manager-discovery/place/:id',
    component: ManagerDiscoveryPlaceDetails,
    loginTypes: ['INTRANET'],
  },

  // MANAGER GIFT
  {
    path: ENDPOINT.MANAGER_GIFT_CREATE,
    component: ManagerGiftCreate,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: ENDPOINT.MANAGER_GIFT_EXCHANGE,
    component: ManagerGiftExchange,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: '/manager-gifts/exchange/:id',
    component: ManagerGiftExchangeDetail,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: ENDPOINT.MANAGER_GIFT_LIST,
    component: ManagerGiftList,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: `${ENDPOINT.MANAGER_GIFT_VOUCHER_CAMPAIGN}/detail/:campaignId`,
    component: ManagerVoucherCampaign,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: ENDPOINT.MANAGER_GIFT_VOUCHER_CAMPAIGN,
    component: ManagerVoucherCampaign,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: ENDPOINT.MANAGER_GIFT_VOUCHER,
    component: ManagerVoucher,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: ENDPOINT.MANAGER_FLIGHT_BOOKING,
    component: ManagerFlightBooking,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: ENDPOINT.MANAGER_FLIGHT_BOOKING_DETAIL_PATH,
    component: ManagerFlightBookingDetail,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: ENDPOINT.MANAGER_FLIGHT_SETTING,
    component: ManagerFlightSetting,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: ENDPOINT.MANAGER_FLIGHT_REVENUE,
    component: ManagerFlightRevenue,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  {
    path: ENDPOINT.MANAGER_GIFT_DETAIL_PATH,
    component: ManagerGiftListDetail,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  // MANAGER MARKET
  {
    path: LOCATIONS.MANAGER_MARKET,
    component: ManagerMarket,
    exact: true,
  },
  {
    path: LOCATIONS.LIST_OF_AREAS,
    component: ManagerAreas,
    exact: true,
  },

  // MANAGER PROMOTION
  {
    path: LOCATIONS.MANAGER_OPERATION,
    component: ManagerOperation,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: LOCATIONS.MANAGER_COIN,
    component: ManagerCoin,
    exact: true,
    loginTypes: ['INTRANET'],
  },
  {
    path: LOCATIONS.MANAGER_PROMOTION,
    component: ManagerPromotion,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  // MANAGER REVENUE
  {
    path: LOCATIONS.MANAGER_REVENUE,
    component: ManagerRevenue,
    exact: true,
  },

  // MANAGER PAYMENT
  {
    path: LOCATIONS.MANAGER_PAYMENT,
    component: ManagerPayment,
    exact: true,
  },
  {
    path: LOCATIONS.MANAGER_PAYMENT_DETAIL,
    component: PaymentDetail,
    exact: true,
  },

  // MANAGER TAX
  {
    path: LOCATIONS.MANAGER_TAX,
    component: ManagerTax,
    exact: true,
    loginTypes: ['INTRANET'],
  },

  // MANAGER COMPLAINT
  {
    path: LOCATIONS.MANAGER_COMPLAINT,
    component: ManagerComplaint,
    exact: true,
  },
  {
    path: LOCATIONS.MANAGER_COMPLAINT_DETAIL,
    component: ComplaintDetail,
    exact: true,
  },

  // MANAGER REFLECT
  {
    path: LOCATIONS.MANAGER_REFLECT || LOCATIONS.MANAGER_TCXH_FEEDBACK,
    component: ManagerReflect,
    exact: true,
  },
  {
    path: LOCATIONS.MANAGER_REFLECT_DETAIL || LOCATIONS.MANAGER_TCXH_FEEDBACK_DETAIL,
    component: TcxhFeedbackDetail,
    exact: true,
  },

  // this route should be at the end of all other routes
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={LOCATIONS.LOCATION_LIST} />,
  },
];

const publicRoutes = [
  { path: LOCATIONS.LOGIN, exact: true, component: Login },
  { path: LOCATIONS.FORGOT_PASSWORD, exact: true, component: ForgotPwd },
  { path: LOCATIONS.REGISTER, exact: true, component: Register },
  { path: LOCATIONS.CREATE_PASSWORD, exact: true, component: CreatePassword },
];

export { publicRoutes, authProtectedRoutes };
